import React, { useState, useRef, useEffect } from 'react';
import HeaderMenu from "../../Header/header-menu";
import Header from "../../Header/header";
import Footer from "../../Footer/Footer";
import TermsConditions from "../../TermsConditions/TermsConditions";
import Isi from "../../ISI/Isi";
import IsiFrame from "../../ISI/Isi-frame";
import './Saving-and-support.css'
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import MainLayout from '../../Layouts/Main_Layout';
import NurseEducatorComponent from '../../NurseEducatorComponent/NurseEducatorComponent';

export default function SavingSupport() {
  const location = useLocation();
  const [saving, setSaving] = useState(false)
  const [support, setSupport] = useState(false)
  const supportRef = useRef(null)
  const myRef = useRef(null)
  const submenu = useRef(null)
  const [show, setShow] = useState(true)

  const executeScroll = () => {
    var element = myRef.current;
    var headerOffset = 39;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    if (getChromeVersion() > 60) {
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    else {
      window.scrollTo(0, offsetPosition);
    }
    setShow(true)
  }
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const handleImageLoads = () => {
    // Check if all images have finished loading
    const allImagesLoaded = Array.from(document.querySelectorAll('img')).every((image) => image.complete);

    if (allImagesLoaded) {
      setImagesLoaded(true);
    }
  };

  const getChromeVersion = () => {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (raw) {
      return parseInt(raw[2], 10);
    }
    else {
      return 100;
    }
  }

  function handleAboutCSS() {
    if (document.getElementById('savings-and-support-page')) {
      const savingRef = document.getElementById('savingRef');
      let offsetTop1 = savingRef.offsetTop - 100;
      const element2 = document.getElementById('supportRef');
      let offsetTop2 = element2.offsetTop - 100;
      if (window.scrollY > offsetTop1) {
        document.getElementById('saving-link').classList.add('submenu-style-active');
      }
      if (window.scrollY > offsetTop2) {
        document.getElementById('saving-link').classList.remove('submenu-style-active');
        document.getElementById('saving-link').classList.add('submenu-style-not-active');
      }

      if (window.scrollY > offsetTop2) {
        document.getElementById('support-link').classList.add('submenu-style-active');
      }
      else {
        document.getElementById('support-link').classList.remove('submenu-style-active');
        document.getElementById('support-link').classList.add('submenu-style-not-active');
      }
    }
  }

  useEffect(() => {
    document.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('button')) {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
          if (document.location.pathname.includes('/what-are-off-periods')) {
            window.gtag('event', 'what_are_off_periods_buttons');
          }
          if (document.location.pathname.includes('/about-inbrija')) {
            window.gtag('event', 'about_inbrija_buttons');
          }
          if (document.location.pathname.includes('/how-to-use-inbrija')) {
            window.gtag('event', 'how_to_use_inbrija_buttons');
          }
          if (document.location.pathname.includes('/savings-and-support')) {
            window.gtag('event', 'savings_and_support_buttons');
          }
        }
      }
    });
    handleAboutCSS();
    if (location.hash === '#savings-programs') {
      const element = document.getElementById('savingRef');
      const savingRefOffset = 45;
      var savingRefPosition = element.getBoundingClientRect().top;
      var savingRefOffsetPosition = savingRefPosition + window.pageYOffset - savingRefOffset;

      if (getChromeVersion() > 60) {
        window.scrollTo({
          top: savingRefOffsetPosition,
          behavior: "smooth"
        });
      }
      else {
        window.scrollTo(0, savingRefOffsetPosition);
      }
      setSaving(true);
      setSupport(false);
    }

    if ((location.hash === '#prescription-services') || (location.hash === '#prescription-support')) {
      const element = document.getElementById('supportRef');
      const supportRefOffset = 45;
      var supportRefPosition = element.getBoundingClientRect().top;
      var supportRefOffsetPosition = supportRefPosition + window.pageYOffset - supportRefOffset;

      if (getChromeVersion() > 60) {
        window.scrollTo({
          top: supportRefOffsetPosition,
          behavior: "smooth"
        });
      }
      else {
        window.scrollTo(0, supportRefOffsetPosition);
      }
      setSaving(false);
      setSupport(true);
    }
    if (location.pathname === '/savings-and-support' || location.pathname === '/savings-and-support/') {
      var windowHeight = window.innerHeight;
      var header = document.getElementById('submenu');

      window.addEventListener('scroll', function () {
        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollPosition > windowHeight) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
      });
    }
    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("scroll", handleAboutCSS);

        return () => {
          window.removeEventListener("scroll", handleScroll);
          window.removeEventListener("scroll", handleAboutCSS);
        };
      }
    };
    calculateOffset();
    window.addEventListener('resize', calculateOffset);

    const handleHashChange = () => {
      // Reset the images loaded status
      setImagesLoaded(false);
    };

    window.addEventListener('hashchange', handleHashChange);

    const metaTags = [];

    // Define the metadata
    const metadata = [
      { property: 'og:title', content: `Savings and Support | INBRIJA® (levodopa inhalation powder)` },
      { property: 'og:description', content: `Explore what savings options are available and how Patient Support Services can assist you after receiving an INBRIJA prescription. Limitations and restrictions apply. See Indication, Important Safety Information, and Patient Information Leaflet.` },
      { property: 'og:site_name', content: 'INBRIJA.COM' },
      { property: 'og:type', content: 'website' },
      { name: 'description', content: `Explore what savings options are available and how Patient Support Services can assist you after receiving an INBRIJA prescription. Limitations and restrictions apply. See Indication, Important Safety Information, and Patient Information Leaflet.` },
    ];

    // Iterate over the metadata and create meta tags
    metadata.forEach((meta) => {
      const metaTag = document.createElement('meta');
      if (meta.name) {
        metaTag.setAttribute('name', meta.name);
      }
      if (meta.property) {
        metaTag.setAttribute('name', meta.property);
      }
      metaTag.setAttribute('content', meta.content);
      metaTags.push(metaTag);
    });

    // Get the <head> element
    const head = document.head;

    const titleTag = head.querySelector('title');
    // Insert the meta tags before the first child of the <head> element
    metaTags.forEach((metaTag) => {
      head.insertBefore(metaTag, titleTag.nextSibling);
    });


    return () => {
      window.removeEventListener('resize', calculateOffset);
      window.removeEventListener('hashchange', handleHashChange);
      metaTags.forEach((metaTag) => {
        head.removeChild(metaTag);
      });
    };
  }, [location, imagesLoaded]);

  if (imagesLoaded) {
    var windowWidth = window.innerWidth;
    var header = document.getElementById('submenu');
    window.addEventListener('scroll', function () {
      const headerRect = header.getBoundingClientRect();
      if (headerRect.top < 0) {
        if (!header.classList.contains("sticky")) {
          header.classList.add('sticky');
        }
      }
      else {
        if (header.classList.contains("sticky")) {
          header.classList.remove('sticky');
        }
      }
      if (windowWidth < 767) {
        header.classList.remove('sticky');
      }
    });
  }

  return (
    <MainLayout>
      <div className='saving-and-support-page' id='savings-and-support-page'>
        <Helmet>
          <title>Savings and Support | INBRIJA® (levodopa inhalation powder)</title>
          <meta property='og:title' content={`Savings and Support | INBRIJA® (levodopa inhalation powder)`} />
          <meta property='og:description' content={`Explore what savings options are available and how Patient Support Services can assist you after receiving an INBRIJA prescription. Limitations and restrictions apply. See Indication, Important Safety Information, and Patient Information Leaflet.`} />
          <meta property='og:site_name' content='INBRIJA.COM' />
          <meta property='og:type' content='website' />
          <meta name='description' content={`Explore what savings options are available and how Patient Support Services can assist you after receiving an INBRIJA prescription. Limitations and restrictions apply. See Indication, Important Safety Information, and Patient Information Leaflet.`} />
          <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
          <meta property='og:url' content='https://inbrija.com/savings-and-support' />
          <meta property='og:image:alt' content='INBRIJA logo' />
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className='hero-section-saving'>
            <div className="container-1500">
              <div className='hero-section'>
                <div className='hero-section-image'>
                  <img onLoad={handleImageLoads} src="/assets/images/saving-herodesktop-img.webp" className='img-fluid desktop-image' alt={`Someone zipping up a coat with the words "I won't give up" on the chest."`} loading='lazy' />
                  <div className="actor_portrayal">Actor portrayal.</div>
                </div>
                <div className='hero-section-content'>
                  <h4>Savings with INBRIJA</h4>
                  <h1>Merz is <span>committed to helping</span> patients access affordable <br className='br-overscreen' />treatment with INBRIJA</h1>
                </div>
              </div>
            </div>
          </div>
        </HeaderMenu>
        <div className='menu-bar-sticky-desktop'>
          <div className="brush-style-2" id="submenu" ref={submenu}>
            <div className="submenu-style">
              <Link className='text-decoration-none' to="/savings-and-support#savings-programs"> <div id='saving-link' className={saving ? 'submenu-style-active pointer' : 'submenu-style-not-active pointer'}>Savings Programs</div></Link>
              <Link className='text-decoration-none' to="/savings-and-support#prescription-services">  <div id='support-link' className={support ? 'submenu-style-active pointer' : 'submenu-style-not-active pointer'}>Patient Support Services</div></Link>
            </div>
          </div>
        </div>
        <div className='menu-bar-sticky-mobile'>
          <div className='mobile-header-sticky brush-style-2'></div>
        </div>
        <div className='saving-program-container' id='savingRef'>
          <div className='saving-program-container-title-section saving-container'>
            <div className='container'>
              <h2>If you or someone you care for want to know how they can save when starting INBRIJA, there are options.</h2>
              <p>Below are the different savings programs that are offered to help you when starting INBRIJA.</p>
            </div>
          </div>
          <div className='saving-program-container-content-section'>
            <div className='container'>
              <ul>
                <li>
                  <div className='saving-program-container-content-section-image'>
                    <img onLoad={handleImageLoads} src='/assets/images/pay-programs.webp' alt='RX illustration' className='img-fluid' />
                    <h3 className='show_mobile'>$0 Co-Pay Program and Ongoing Assistance*</h3>
                  </div>
                  <div className='saving-program-container-content-section-text'>
                    <h3 className='show_desktop'>$0 Co-Pay Program and Ongoing Assistance*</h3>
                    <p>Commercially insured patients may be eligible to save on their out-of-pocket costs and pay as little as $0 for INBRIJA, each time they fill their prescription.</p>
                    <p>Patient Support Services can confirm whether your insurance will cover your prescription and whether you are eligible for patient co-pay savings. If you have commercial insurance (employer-sponsored or individual) and INBRIJA is covered, you may be eligible to receive INBRIJA for as little as $0 per month, where allowed by law. Patients who participate in Medicaid, Medicare, or any other US federal healthcare program are not eligible to receive co-pay assistance.</p>
                  </div>
                </li>
                <li>
                  <div className='saving-program-container-content-section-image'>
                    <img onLoad={handleImageLoads} src='/assets/images/asistant-program.webp' alt='Assistance illustration' className='img-fluid' />
                    <h3 className='show_mobile'>Patient Assistance Program</h3>
                  </div>
                  <div className='saving-program-container-content-section-text'>
                    <h3 className='show_desktop'>Patient Assistance Program</h3>
                    <p>If you cannot afford INBRIJA, Patient Support Services may be able to help. You may be eligible for the Patient Assistance Program, which is designed to help you get INBRIJA at no cost. Ask us for more information about the program and how to apply.</p>
                  </div>
                </li>
                <li>
                  <div className='saving-program-container-content-section-image'>
                    <img onLoad={handleImageLoads} src='/assets/images/help-program.webp' alt='First aid kit illustration' className='img-fluid' />
                    <h3 className='show_mobile'>Medicare Extra Help Program</h3>
                  </div>
                  <div className='saving-program-container-content-section-text'>
                    <h3 className='show_desktop'>Medicare Extra Help Program</h3>
                    <p>If you are enrolled in Medicare and have limited financial resources, you may qualify for the Medicare Extra Help program to help pay for some healthcare and prescription drug costs. Ask us for information about how to apply for the program. The Medicare Extra Help program is a federal program and is not managed by Merz.</p>
                    <p className='disclaimer-text'>Limitations and restrictions apply. For more information, call 1-833-INBRIJA (1-833-462-7452). The dispensing pharmacy will submit a claim to your insurance carrier. Merz Therapeutics, LLC. will reimburse the dispensing pharmacy in the amount of your out-of-pocket cost, subject to certain maximum amounts per month and per year as determined based on your pharmacy benefit plan.</p>
                    <div className='saving-program-container-content-section-image-call'>
                      <div className='saving-program-container-content-section-image-call'>
                        <img onLoad={handleImageLoads} src='/assets/images/call-icon.webp' alt="Phone and chat icon" className='call-icon-img' />
                      </div>
                      <div className='saving-program-container-content-section-text'>
                        <p>If you have questions about INBRIJA or would like to speak with a Nurse Educator for additional training tips, please contact Patient Support Services directly. </p>
                        <h3 className='call'> Call toll-free <a href="tel:1-833-462-7452" className='call' id='savings_888_1'>1-833-INBRIJA (1-833-462-7452)</a></h3>
                        <p>8 <small>AM</small> to 8 <small>PM</small> Eastern Time, Monday through Friday</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='prescription-support-container' ref={supportRef} id="supportRef">
          <div className='prescription-support-container-title-section'>
            <div className="container">
              <h2>Here's what to expect once your doctor prescribes INBRIJA</h2>
              <h5>Patient Support Services is here to help</h5>
              <p>Patient Support Services works together with your doctor and a specialty pharmacy. If you have questions about how to use INBRIJA or need assistance understanding your insurance coverage, you can talk to Patient Support Services.</p>
              <hr />
            </div>
          </div>
          <div className='prescription-support-container-content-section'>
            <div className='container'>
              <ul>
                <li>
                  <div className='prescription-support-container-content-section-image'>
                    <img onLoad={handleImageLoads} src='/assets/images/headset.webp' alt='Headset illustration' className='img-fluid' />
                  </div>
                  <div className='prescription-support-container-content-section-text'>

                    <h3>1. Call Patient Support Services at <a href="tel:1-833-462-7452" className="call">1-833-INBRIJA</a> for help with:</h3>
                    <ul>
                      <li>Determining what kind of coverage you have</li>
                      <li>Reviewing coverage and financial assistance options (if you are eligible)</li>
                      <li>Ensuring that you know how to use INBRIJA</li>
                    </ul>
                    <div className='extra-info'>
                      <p>It is highly recommended to speak with Patient Support Services, call us at <a href="tel:1-833-462-7452" id='savings_888_2'>1-833-462-7452</a>.</p>
                    </div>
                  </div>
                </li>

                <li>
                  <div className='prescription-support-container-content-section-image'>
                    <img onLoad={handleImageLoads} src='/assets/images/delivery.webp' alt='Delivery truck illustration' className='img-fluid' />
                  </div>
                  <div className='prescription-support-container-content-section-text'>
                    <h3>2. You will get your INBRIJA delivery from a specialty pharmacy</h3>
                    <ul>
                      <li>A specialty pharmacy representative will call you to arrange payment details and delivery of INBRIJA</li>
                      <li>A specialty pharmacy will follow up with refills as prescribed</li>
                    </ul>
                    <div className='extra-info'>
                      <p>You must speak to the specialty pharmacy representative who calls to confirm your shipment. Calls may come from an unrecognized phone number.</p>
                    </div>
                  </div>
                </li>

                <li>
                  <div className='prescription-support-container-content-section-image'>
                    <img onLoad={handleImageLoads} src='/assets/images/support.webp' alt='Outstretched hand illustration' className='img-fluid' />
                  </div>
                  <div className='prescription-support-container-content-section-text'>
                    <h3>3. Speak with a Nurse Educator to:</h3>
                    <ul>
                      <li>Review device training either by phone or connecting through a video</li>
                      <li>Review contents of your Start Kit</li>
                      <li>Schedule follow-up calls</li>
                    </ul>
                    <div className='extra-info'>
                      <p>Speaking with a Nurse Educator is highly recommended. You may contact them at <a href="tel:1-833-462-7452" id='savings_888_3'>1-833-INBRIJA (1-833-462-7452)</a>.</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="nurse-educator-section-wrapper pt-4">
          <div className="container">
            <div className="row">
              <div className="col-12 full-header text-start">
                <h1>
                  <strong>Nurse Educators are on call</strong> to help you gain confidence using <span className="text-nowrap">your INBRIJA</span>
                </h1>
              </div>
            </div>
          </div>
          <div className="nurse-educator-component-wrapper">
            <NurseEducatorComponent />
          </div>
        </div>

        <div className="navigation-bar">
          <div className="row">
            <div className="col-md-12">
              <a id="savings_learn_how_use" href="/how-to-use-inbrija#learn-how-use-inbrija"> Learn How to Use INBRIJA </a>
            </div>
          </div>
        </div>
        <TermsConditions />
        <hr />
        <div ref={myRef}>
          <Isi />
        </div>
        {
          show ? <IsiFrame onClick={executeScroll} /> : ''
        }
        <Footer year="2023" partNum="05/25 US-INB-2500205" code="06/23 INB13297" 
          twitterCode={location.hash === '#prescription-support' || '#prescription-services' ? 'https://twitter.com/intent/tweet?text=Prescription%20Support%20Services.%20Prescription%20Support%20Services%20is%20available%20to%20help%20you!%20https://www.inbrija.com/prescription-support-services' :
            'https://twitter.com/intent/tweet?text=Savings%20Programs.%20Learn%20more%20about%20the%20savings%20programs%20that%20are%20offered%20to%20you.%20https://www.inbrija.com/savings-programs'}
          facebookLink={location.hash === '#prescription-support' || '#prescription-services' ? 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2Fprescription-support-services&title=Prescription%20Support%20Services&description=Prescription%20Support%20Services%20is%20available%20to%20help%20you!' :
            'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2Fsavings-programs&title=Savings%20Programs&description=Learn%20more%20about%20the%20savings%20programs%20that%20are%20offered%20to%20you.'
          }
          title="Savings and Support | INBRIJA® (levodopa inhalation powder)"
        />
      </div>
    </MainLayout>
  );
}